import React from "react"
import HubspotForm from "react-hubspot-form"

import "./hubspot-form.scss"

/**
 * @param {{
 *   region?: string,
 *   portalId?: string,
 *   formId: string
 * }} param0
 * @returns
 */
const RequestDemoPage = ({region = "na1", portalId = "7162442", formId}) => {
  return (
    <HubspotForm
      region={region}
      portalId={portalId}
      formId={formId}
      onSubmit={() => console.log("Submit!")}
      onReady={form => console.log("Form ready!")}
      loading={<div className="hs-form-loading">Loading...</div>}
    />
  )
}
export default RequestDemoPage
